import { render, staticRenderFns } from "./team-message-consent.vue?vue&type=template&id=67a1de62"
import script from "./team-message-consent.vue?vue&type=script&lang=js"
export * from "./team-message-consent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports